import { Component, Inject, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { FormulaTesterComponent, Variable } from 'src/app/forms/formula-tester/formula-tester.component';
import { ListOption, parameter } from 'src/app/interfaces/action';
import { DialogService } from 'src/app/services/dialog.service';
import { FormServices } from 'src/app/services/form.services';
import { HTTPService } from 'src/app/services/http.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { ThemeService } from 'src/app/services/theme.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';

export class Types {
    type:string;
    name:string;
    description:string;
}



@Component({
    selector: 'form-field-properties-detail-actions-params',
    templateUrl: './form-field-properties-detail-actions-params.component.html',
    styleUrls: ['./form-field-properties-detail-actions-params.component.scss'],
    standalone: false
})
export class FormFieldPropertiesDetailActionsParamsComponent implements OnInit {
  selectedIndex: number;

  constructor(private http:HTTPService, private uas:UserAuthenticationServices,
    private fb:UntypedFormBuilder, private fs:FormServices, 
    private snackBar:SnackbarService,
    @Inject(MAT_DIALOG_DATA) public data, 
    public dialogRef:MatDialogRef<any>,

    public ThemeService:ThemeService) { }

  @Input() entityName:string;
  //@Input() columnName:string;
  @Input() prefName:string;
  @Input()row:Object;
  selectedItem:Object = null;
  /** spinner NG-ZORRO (substitui o ngx-spinner 'actionpref') */
  actionLoading = false;
  formAction:UntypedFormGroup;
  sub3:Subscription;
  condition:string ="0=1";
  parameters:parameter[] = [];
  showParameter:boolean = false;
  parameterType;
  parameterName;
  parameterDesc;
  entityOrigem;
  listOption:ListOption[] = [];
  listOptionStr;
  entityOrigemList:{entityName:string,entityDesc:string, apresentationField:string}[]=[];
  visibleParam:boolean = false;
  types:Types[] = [];
  editingItem = false;
  ngOnDestroy(){
      if (this.sub3 !=null) { this.sub3.unsubscribe()}
  }

  get codeCompany(){
      return this.data.CODECOMPANY;
  }

  
  get codeContract(){
    return this.data.CODECONTRACT;
  }

  getTypeDescription(type){
      let t= this.types.find(d=>d.type == type);
      if ( t != null){
        return t.description;
      }else{
        return "";
      }
  }

  onSelectEntity(){
      if (this.parameterType == 'R'){
        this.parameterName = this.entityOrigemList.find(d=>d.entityName==this.entityOrigem).apresentationField;
      }else{
        this.parameterName = null;
      }
  }

  loadInstances(){
    return new Promise((resolve,reject)=>{
      
      let ob = {
        "entityName":"Mktpdic",
        "sql":`SELECT INSTANCENAME entityName , INSTANCEDESC entityDesc, (
          SELECT TOP 1 * FROM
          (SELECT  COLUMNNAME 
          FROM MKTPDICCOL A 
          WHERE A.IDINSTANCE=MKTPDIC.IDINSTANCE 
          AND (A.ISIDENTITY=1   OR  INCREMENTALFIELD=1 )
          UNION ALL
          SELECT COLUMNNAME 
          FROM MKTPDICCOL A
          WHERE A.IDINSTANCE=MKTPDIC.IDINSTANCE 
          AND NOT EXISTS( SELECT 1 FROM MKTPDICCOL B WHERE A.IDINSTANCE=B.IDINSTANCE AND (B.ISIDENTITY=1   OR  B.INCREMENTALFIELD=1 ))
          AND ISPK=1
          AND ISFK=0
          )A)  +'->'+APRESENTATIONFIELD apresentationField
        FROM MKTPDIC
        WHERE APRESENTATIONFIELD IS NOT NULL`
      }
     
      this.http.post(ob,'JsonBrokerServices/findnative',false,true,true).subscribe({
        next:(data)=>{
          if ( data && data['SQL']){
              this.entityOrigemList  = data['SQL'];
          }
          resolve(true);
        },
        error:(error)=>{
          throw error;
        }
      });
    });
    
  }

  ngOnInit(): void {
      
      this.loadInstances();

      this.types = [{type: "S" , name: "VARCHAR" , description:"Texto"},
      {type: "D" , name: "DATETIME" , description:"Data/Hora"},
      {type: "N" , name: "FLOAT" , description:"Número"},
      {type: "I" , name: "INT" , description:"Inteiro"},
      {type: "L" , name: "SELECT" , description:"Opções"},
      {type: "R" , name: "SEARCHREFERENCE" , description:"Pesquisa"}];

      this.prefName = this.data.prefName+'_PARAM';
      
      this.formAction = this.fb.group({
        INTERNALID:new UntypedFormControl({value:null,disabled:true}),
        CODECOMPANY:new UntypedFormControl({value:this.data.CODECOMPANY,disabled:true}),
        CODECONTRACT:new UntypedFormControl({value:this.data.CODECONTRACT,disabled:true}),
      });
      this.loadConfiguration();
      
  }

  loadConfiguration(){
    if (  this.prefName !=null ){
      this.actionLoading = true;
      let ob = {
      "entityName":"Mktpcontractpref",
      "sql":`SELECT  CONVERT(VARCHAR(100),B.CODECOMPANY)+' - ' +B.NAME COMPANY,A.CODECOMPANY,A.INTERNALID,A.NAME,A.TEXT, A.CODECONTRACT
            FROM MKTPCONTRACTPREF A INNER JOIN MKTPCOMPANIES B ON A.CODECOMPANY=B.CODECOMPANY
            WHERE A.CODECONTRACT IN (${this.codeContract}) 
            AND A.CODECOMPANY IN (${this.codeCompany})
            AND A.NAME= '${this.prefName}'
            ORDER BY 1`
    }
     
    this.http.post(ob,'JsonBrokerServices/findnative',false,true,true).subscribe({
        next:  (data)=>{
            if ( data['SQL'] && data['SQL'][0] && data['SQL'][0]['TEXT']){
              this.parameters = JSON.parse(data['SQL'][0]['TEXT']);
              this.formAction.get("INTERNALID").setValue(data['SQL'][0]['INTERNALID']);
              this.showParameter = true;
            }
            this.actionLoading = false;
        },
        error: (error)=>{
            this.actionLoading = false;
            throw error;
        }
    });

    }
  }

  deleteItem(event:Event , item){
    let i = this.parameters.indexOf(item);
    if ( i>-1){
        this.parameters.splice(i,1);
    }
  }

  editItem(item:parameter, index:number){
      this.visibleParam = true;
      this.selectedItem = item;
      this.selectedIndex = index;
      this.parameterDesc = item.parameterDesc;
      this.parameterName = item.parameterName;
      this.parameterType = item.parameterType;
      this.entityOrigem = item.entityOrigem;

      //  if ( this.parameterType == 'R'){
      //    if ( this.entityOrigemList.length > 0 ){
      //      this.entityDesc = this.entityOrigemList.find(d=>d.entityName==this.entityOrigem).entityDesc;
      //    }
      // }

      if ( this.parameterType == 'L'){
        if ( item.listOption!= null && item.listOption.length > 0 ){
          let str = "";
          
          for ( var i of item.listOption){
              if ( str == ""){
                str = str + i.value + '=' + i.view;
              }else{
                str = str + "\n"+i.value + '=' + i.view;
              }
              
          }
          this.listOptionStr = str;
        }
      }

  }

  addItem(){

      let ob:parameter = {
          parameterName: this.parameterName,
          parameterDesc: this.parameterDesc,
          parameterType: this.parameterType
      }

      if ( this.parameterType == 'R'){
        if ( this.entityOrigemList.length > 0 ){
          ob.entityOrigem= this.entityOrigem;
          ob.entityDesc = this.entityOrigemList.find(d=>d.entityName==this.entityOrigem).entityDesc;
        }
      }

      if ( this.parameterType == 'L'){
        if ( this.listOptionStr != null ){
          let itens:string[]  = this.listOptionStr.split('\n');
          for ( var item of itens ){
              let value = item.split('=')[0];
              let view = item.split('=')[1];
              let ob:ListOption = {
                  value: value,
                  view: view
              }
              this.listOption.push(ob);
          }
          ob.listOption = this.listOption;
        }
      }

      if ( this.selectedItem != null ){
        this.parameters[this.selectedIndex] = ob;
      }else{
        this.parameters.push(ob);
      }
      this.clearItem();
  }

  clearItem(){
      this.selectedIndex = -1;
      this.selectedItem = null;
      this.parameterName = null;
      this.parameterDesc = null;
      this.parameterType = null;
      this.entityOrigem = null;
      this.listOption = [];
      this.visibleParam = false;
  }


  cancelEdit(){ 
      this.dialogRef.close();
  }

  novo(){
    this.clearItem();
    this.visibleParam = true;
  }

  

  salvar(){
    this.actionLoading = true;
    
    let jsonSave:Object = {
      "entityName":"Mktpcontractpref",
    }

    let action = 'save';
    if (this.parameters.length == 0 ){
        jsonSave["INTERNALID"]  = this.formAction.get("INTERNALID").value;
        action = 'remove';
    }else{
        if ( this.formAction.get("INTERNALID").value != null ){
          jsonSave["INTERNALID"]  = this.formAction.get("INTERNALID").value;
        }
        jsonSave["CODECOMPANY"]= this.formAction.get("CODECOMPANY").value;
        jsonSave["CODECONTRACT"]= this.formAction.get("CODECONTRACT").value;
        jsonSave["NAME"] = `${this.prefName}`;
        jsonSave["DESCRIPTION"]= `Busca ${this.prefName} no ERP`;
        jsonSave["TYPE"]= 'T';
        jsonSave["CODEMKTP"]= '0';
        jsonSave["TEXT"]=JSON.stringify(this.parameters);
    }

    this.sub3 = this.http.post(jsonSave,"JsonBrokerServices/"+action,true).subscribe({
        next:(sucesso)=>{
            this.snackBar.showSuccess('Parâmetros registrados com sucesso.')
            this.actionLoading = false;
            this.dialogRef.close();
        },
        error:(error)=>{
            this.actionLoading = false;
            throw error;
        }
    });
  }

  
}
